import { AuthContext } from '../contexts/contexts';

export const Auth = ({ children, values }) => (
  <AuthContext.Provider value={values}>{children}</AuthContext.Provider>
);
